<ul class="sc-action-menu__list">
  <li *ngFor="let action of items" class="sc-action-menu__list-item">
    <a
      class="sc-action-menu__list-item-link"
      [attr.id]="action.id"
      (click)="actionClicked.emit(action)">
      <sc-icon
        class="sc-action-menu__list-item-icon"
        [icon]="action.icon" size="1"></sc-icon>
      {{action.label}}
    </a>
  </li>
</ul>
